// src/components/RouteTitleManager.tsx
import { useEffect } from 'react'
import { useLocation, matchPath } from 'react-router-dom'

const RouteTitleManager = () => {
  const location = useLocation()

  useEffect(() => {
    const pathname = location.pathname

    const routes: {
      path: string
      title: string | ((params: Record<string, string>) => string)
    }[] = [
      {
        path: '/',
        title:
          'QC Express – Trusted Logistics Company in Lagos | Fast & Reliable Logistics Services Near You',
      },
      { path: '/create-account', title: 'Create Account | QC Express' },
      { path: '/forgot-password', title: 'Forgot Password | QC Express' },
      { path: '/reset', title: 'Reset Password | QC Express' },
      {
        path: '/terms-and-conditions',
        title: 'Terms & Conditions | QC Express',
      },
      { path: '/privacy-policy', title: 'Privacy Policy | QC Express' },
      { path: '/users/login', title: 'User Login | QC Express' },
      { path: '/aggregators/login', title: 'Aggregator Login | QC Express' },
      { path: '/blogs', title: 'Blog Page | QC Express' },
      {
        path: '/aggregator/:page',
        title: ({ page }) =>
          `${formatPageTitle(page)} | Aggregator | QC Express`,
      },
      {
        path: '/aggregator/:page/:id',
        title: ({ page }) =>
          `${formatPageTitle(page)} Details | Aggregator | QC Express`,
      },
      {
        path: '/user/:page',
        title: ({ page }) => `${formatPageTitle(page)} | User | QC Express`,
      },
      {
        path: '/user/:page/:id',
        title: ({ page }) =>
          `${formatPageTitle(page)} Details | User | QC Express`,
      },
    ]

    for (const route of routes) {
      const match = matchPath(route.path, pathname)
      if (match) {
        const title =
          typeof route.title === 'function'
            ? route.title(match.params as Record<string, string>)
            : route.title
        document.title = title
        return
      }
    }

    // Default title if no route matched
    document.title =
      'QC Express – Trusted Logistics Company in Lagos | Fast & Reliable Logistics Services Near You'
  }, [location])

  return null
}

// Helper: Format page slug into Title Case
function formatPageTitle(slug: string = '') {
  return slug
    .split('-')
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join(' ')
}

export default RouteTitleManager
